import { Box, Tab, Tabs } from '@mui/material'
import { IconButton, TabPanel } from 'components'
import { PageContent } from 'layout'
import { useLayoutContext } from 'layout/layout.context'
import { useEffect, useState } from 'react'
import { MdKeyboardArrowLeft } from 'react-icons/md'
import { useNavigate, useParams } from 'react-router'
import { Address } from './tabs/Address'
import { Contacts } from './tabs/Contacts'
import { General } from './tabs/General'

export const CustomerDetailsPage = () => {
  const navigation = useNavigate()
  const [value, setValue] = useState(0)
  const { id } = useParams()
  const { setBreadcrumbs } = useLayoutContext()

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  useEffect(() => {
    setBreadcrumbs([
      { label: 'Início', to: '/home' },
      { label: 'Clientes', to: '/customers' },
      { label: `Cliente ${id || ''}`, copyText: id || '' }
    ])
    return () => setBreadcrumbs([])
  }, [id])

  return (
    <div>
      <PageContent>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            width: '100%',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <IconButton onClick={() => navigation('/customers')} sx={{ mr: 1 }}>
            <MdKeyboardArrowLeft size={24} color="#565656" />
          </IconButton>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons={true}
            allowScrollButtonsMobile
          >
            <Tab label="Geral" />
            <Tab label="Endereços" />
            <Tab label="Contatos" />
          </Tabs>
        </Box>
        <Box>
          <TabPanel value={value} index={0}>
            <General />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Address />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Contacts />
          </TabPanel>
        </Box>
      </PageContent>
    </div>
  )
}
export default CustomerDetailsPage
